import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TypeHandicap } from 'src/app/shared/models/typeHandicap';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class TypeHandicapService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllTypeHandicaps(): Observable<TypeHandicap[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.typeHandicapUrl}/all`,
			'getAllTypeHandicaps'
		);
	}

	importTypeHandicap(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'typeHandicaps.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.typeHandicapUrl}/import`,
			`importTypeHandicap`,
			formData
		);
	}

	getTypeHandicapById(id: number): Observable<TypeHandicap> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.typeHandicapUrl}/get/${id}`,
			'getTypeHandicapById'
		);
	}

	updateTypeHandicap(typeHandicap: TypeHandicap): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.typeHandicapUrl}/update/${typeHandicap.id}`,
			'updateTypeHandicap',
			typeHandicap
		);
	}

	addTypeHandicap(typeHandicap: TypeHandicap): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.typeHandicapUrl}/add`,
			'addTypeHandicap',
			typeHandicap
		);
	}

	deleteTypeHandicap(typeHandicapId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.typeHandicapUrl}/delete/${typeHandicapId}`,
			`deleteTypeHandicap`
		);
	}
}
